/**
 * Plugin per gestire l'outline solo per navigazione da tastiera
 * Aggiunge/rimuove classe 'using-keyboard' sul body
 */

export default ({ app }) => {
  if (typeof window === 'undefined') return;

  let usingKeyboard = false;

  // Rileva uso della tastiera
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      usingKeyboard = true;
      document.body.classList.add('using-keyboard');
      document.body.classList.remove('using-mouse');
    }
  });

  // Rileva uso del mouse
  document.addEventListener('mousedown', () => {
    usingKeyboard = false;
    document.body.classList.add('using-mouse');
    document.body.classList.remove('using-keyboard');
  });

  // Rileva click
  document.addEventListener('click', () => {
    if (!usingKeyboard) {
      document.body.classList.add('using-mouse');
      document.body.classList.remove('using-keyboard');
    }
  });
};
